import { Hero } from '@/components/sections/Hero';
import { SectionSummary } from '@/components/sections/SectionSummary';
import { TechnologyMarquee } from '@/components/sections/TechnologyMarquee';
import { ProjectIconStrip } from '@/components/sections/ProjectIconStrip';
import { ContactBand } from '@/components/sections/ContactBand';
import { siteConfig } from '@/data/site-config';
import { useScrollSnap } from '@/hooks/useScrollSnap';
import { StyledHomePage } from './Home.styles';

export const HomePage = () => {
  /* specs/023. The only call to it: the scroll container is <html>, so the snap type has to be scoped to
     the route, and this is the page that is the route. The five bands' `scroll-snap-align` is declared in
     their own components and needs nothing here. */
  useScrollSnap(true);

  return (
    <StyledHomePage>
      <Hero
        name={siteConfig.name}
        title={siteConfig.title}
        tagline={siteConfig.tagline}
        cta={{ label: 'Ver Proyectos', href: '/projects' }}
        secondaryCta={{ label: 'Contactar', href: '/contact' }}
      />
      {/* Order: work first, then the tools, then the person, then the way to reach them.

          The backgrounds alternate strictly, starting from the Hero's own default. Reordering
          the blocks without also reassigning them left Tecnologías and Sobre mí both on
          muted, two identical bands in a row, which reads as a mistake rather than a rhythm.
          So each block moved and the band follows its position, not its name. */}
      <SectionSummary
        id="projects-summary"
        title="Proyectos"
        description="Una selección de proyectos en los que trabajé, tecnologías utilizadas y problemas que resolví."
        ctaLabel="Ver proyectos"
        ctaHref="/projects"
        background="muted"
        featuredItems={<ProjectIconStrip />}
      />
      <SectionSummary
        id="technologies-summary"
        title="Tecnologías"
        description="Las tecnologías y herramientas que utilizo para construir aplicaciones web modernas."
        ctaLabel="Ver tecnologías"
        ctaHref="/technologies"
        background="default"
        featuredItems={<TechnologyMarquee />}
      />
      <SectionSummary
        id="about-summary"
        title="Sobre mí"
        description="Me interesa crear tecnología que tenga sentido. Disfruto transformar ideas en productos digitales, encontrar soluciones a problemas reales y cuidar cada detalle del proceso, desde el concepto hasta su implementación."
        ctaLabel="Conocé más"
        ctaHref="/about"
        background="muted"
      />
      {/* The closing band is not a SectionSummary. specs/020: it carries the address as its
          subject, at display size, as one clickable link with a diagonal arrow, and the shared
          band has no slot for any of that. It keeps this band's id and its accessible name, which
          the browser suite and the region outline both depend on, and it keeps the same shell
          values, so the page's rhythm is unchanged. */}
      <ContactBand />
    </StyledHomePage>
  );
};
